import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="product-info"
export default class extends Controller {
  static targets = ["icon", "text"];

  toggle() {
    this.iconTarget.classList.toggle("rotate-90");
    this.textTarget.classList.toggle("hidden");
  }
}
